<template>
  <div class="zgornji-odmik">
    <div v-loading="nalaganjeTabeleMeilov">
      <div v-if="seznamEmailov.length > 0 || dodeljeniEmaili.length > 0">
        <div v-if="poslovnaStranka === '0'">
          <p class="navadno-besedilo">
            T-2 zagotavlja brezplačne elektronske predale za vsakega (do 5) družinskega člana. V primeru, da ste
            ob naročilu T-2 storitev izbrali manj kot 5 elektronskih predalov, vam jih bomo do 5 dodelili brezplačno.
            Za naročilo ali kreiranje dodatnih elektronskih predalov nas prosimo pokličite na
            {{ kontaktniPodatki.T2_SUPPORT_TEL_ST }}
            <span style="padding-top: 15px; display: block">
              Omogočamo tudi gostovanje elektronske pošte z lastno domeno.
              Več o gostovanju in registraciji domen si lahko preberete na
              <a :href="povezavaElektronskaPosta" class="primarna-barva">
                spletni strani
              </a>.
            </span>
          </p>
        </div>
        <div v-if="poslovnaStranka === '1'">
          <p class="navadno-besedilo">
            Za vsakega zaposlenega v vašem podjetju zagotavljamo brezplačne elektronske predale s kapaciteto 1 GB in
            končnico .net. Elektronski predali na strežniku T-2 so zaščiteni
            <span style="display: block">
                pred virusi in nezaželeno elektronsko pošto(spam).
              </span>
            <span style="padding-top: 15px; display: block">
              Omogočamo tudi gostovanje elektronske pošte z lastno domeno.
              Več o gostovanju in registraciji domen si lahko preberete na
              <a :href="povezavaElektronskaPosta" class="primarna-barva">
                spletni strani
              </a>.
            </span>
          </p>
        </div>
        <span v-show="prikazTabele === '1'" v-if="seznamT2Domen.length > 0" v-loading="nalaganjeTabeleMeilov">
          <div>
            <div>
              <p class="open-sans-20pt">
                E-predal s t-2 domeno
              </p>
            </div>
            <div class="flex-container pt-3 pb-3" v-if="this.izbranPrikljucek !== null">
              <div>
                Domena:
                <b class="primarna-barva">
                  @t-2.net, @t-2.si
                </b>
              </div>
              <div>
                Število ustvarjenih predalov:
                <b class="primarna-barva">
                  {{ seznamEmailov.filter(x => this.validacija.JeT2Domena(x.email)).length }}
                </b>
              </div>
            </div>
              <t2-table
                :rows-per-page="5"
                class="predali"
                header-row-class-name="glava-tabela"
                :data="seznamT2Domen"
                style="width: 100%"
                :expand-row-keys="expandRowKeys"
                :row-key="row => row.email"
                @expand-change="Izbranavrstica">
                <el-table-column label="E-predal" sortable :sort-method="sortByPredal">
                    <template slot-scope="scope">
                      {{ scope.row.email }}
                    </template>
                </el-table-column>
                <el-table-column
                  label="Naziv za prikaz"
                  prop="podatekSn">
                    <template slot-scope="scope">
                      <span v-if="scope.row.podatekSn === ''">
                         <el-icon class="el-icon-warning" style="color: red; font-size: 20px"></el-icon>
                        Predal ni v LDAP-u in ne deluje.
                      </span>
                      <span v-else>
                        {{ scope.row.podatekSn }}
                      </span>
                    </template>
                  </el-table-column>
                <el-table-column label="Datum kreiranja" sortable  :sort-method="sortByDate">
                    <template slot-scope="scope">
                      <span v-if="scope.row.kreiran !== ''">
                        {{ (scope.row.kreiran).slice(0, 10) }}
                      </span>
                    </template>
                </el-table-column>
                  <el-table-column
                    label="Velikost">
                    <template slot-scope="scope">
                      <span v-if="scope.row.ldap !== null">
                        <p class="crna">
                          {{ `${scope.row.ldap.mailquota}B`}}
                        </p>
                      </span>
                      <span v-else>
                       /
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column type="expand">
                    <template slot-scope="scope">
                      <div style="width: auto; margin: auto; padding-bottom: 60px;"
                           v-if="scope.row.nePrikazeGumba !== false" v-loading="nalaganjeInfoPredala">
                        <div class="notranji-odmik">
                          <div class="container">
                            <div class="notranja-postavitev">
                            <p style="font-size: 14px">
                              <b>
                                Psevdonimi
                                <el-tooltip class="item primarna-barva" popper-class="psevdonimi"
                                            content="Elektronskemu naslovu lahko dodate želene
                                            psevdonime (aliase), katere poimenujete po svoji želji
                                            (na primer:janez_novak@t-2.net, janez.novak@t-2.net,
                                            janez_t@t-2.net itd.).Elektronsko pošto naslovljeno na
                                            katerikoli e-poštni psevdonim boste prejemali v vaš
                                            elektronski predal. " placement="bottom">
                                    <el-icon class="el-icon-info"></el-icon>
                                </el-tooltip>
                              </b>
                            </p>
                            <div>
                              <div style="float: left; width: 30%;">
                                <p class="Text-Style visina">
                                  Izbran poštni predal:
                                </p>
                              </div>
                              <div style="float: right; width: 70%;">
                                <p class="primarna-barva krepko crna visina">
                                    {{ scope.row.email }}
                                </p>
                              </div>
                            </div>
                          <div>
                            <div style="float: left; width: 30%; line-height: 0.86;">
                              <p class="primarna-barva-pisave">
                                Psevdonimi:
                              </p>
                            </div>
                            <div style="float: right; width: 70%">
                              <table v-loading="nalaganjePsevdonimov">
                                <tr v-for="(data,index) in seznamNovihKreiranihEmailov"
                                    :key="index" style="border: 1px;">
                                  <td class="stil-tabela-psevdonimi">
                                    <div style="float: left">
                                      <img
                                        src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png"
                                        @click="OdstraniPsevdonim
                                                 (mailZaUrejanjeObj.ldap.mail, data)"
                                        style="padding-right: 10px; cursor: pointer">
                                    </div>
                                  <td class="krepko crna stil-tabela-psevdonimi">
                                    {{ data }}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                          <br style="clear: both"/>
                          <el-form style="padding-top: 30px" label-width="150px" :label-position="formaOrientacija">
                            <el-form-item label="Nov psevdonim">
                              <el-input placeholder="" v-model="novPsevdonim" class="velikost-inputa-psevdonim">
                              </el-input>
                              <span class="postavitev-afne">
                                <b style="padding: 0 10px 0;">
                                  @
                                </b>
                              </span>
                              <el-select v-model="izbranaT2Domena" placeholder="Izberi" class="velikost-inputa-domene">
                                <el-option
                                  v-for="data in t2Domene"
                                  :key="data"
                                  :label="data"
                                  :value="data">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-form>
                          <div style="padding-top: 18px">
                            <el-button @click="DodajNovPsevdonim(mailZaUrejanjeObj.ldap.mail, izbranaT2Domena)"
                                       class="tekst-gumba-dodajanje okvir-gumba-dodajanje
                                      velikost-gumba-psevdonim">
                              USTVARI PSEVDONIM
                            </el-button>
                          </div>
                          <div class="odmik-povecaj-postni-predal">
                            <p class="open-sans-14pt-bold krepko">
                                Velikost poštnega predala
                            </p>
                            <p>
                              <span class="sirina-label visina">
                                Naročena velikost predala:
                              </span>
                              <b>
                                {{ velikostPredala }}
                              </b>
                            </p>
                            <p>
                              <span class="sirina-label">
                                Zasedenost poštnega predala:
                              </span>
                              <b>
                                {{ zasedenProstor }}
                              </b>
                            </p>
                              <template v-if="mailZaUrejanjeObjPravicaUrejanja && mailZaUrejanjeObj !== null">
                                <div style="padding-top: 10px" class="mobile-label"/>
                                <div style="line-height: 40px;">
                                   Spremeni velikost poštnega predala na
                                  <el-select v-model="izbranaVelikostiPredala"
                                             placeholder="Izberi" class="input-povecaj-postni-predal">
                                    <el-option
                                      v-for="data in seznamMoznihVelikosti"
                                      :key="data"
                                      :label="`${data}.00 GB`"
                                      :value="data">
                                    </el-option>
                                  </el-select>
                                  <a :href="povezavaAdministrativneStoritveZasebno"
                                     target="_blank" class="primarna-barva povezava-administrativne-storitve">
                                     Cenik storitev
                                  </a>
                                </div>
                                <div class="pt-2 mb-7">
                                  <OrderButton
                                    v-if="mailZaUrejanjeObj !== null"
                                    :disabled="prvotnoIzbranaVelikost === izbranaVelikostiPredala"
                                    :services="[{
                                        serviceId: StoritevEnum.DODATEN_1GB_EMAIL,
                                        quantity: Number(izbranaVelikostiPredala),
                                        terminationPointId: Number.parseInt(izbranPrikljucek),
                                         additionalData: [
                                          {
                                            key: 'email',
                                            value: mailZaUrejanjeObj.ldap.mail
                                          }
                                        ]
                                    }]"
                                    class="postavitev-gumb-narocanje"
                                    style="max-width: 177px"
                                    service-name=""
                                    @orderConfirmed="GetPrikaziNastavitve(mailZaUrejanjeObj.ldap.mail); GetEmaili()"
                                    custom-notify-text-button="Da, spremeni velikost"
                                    :custom-notify-text="`Ste prepričani, da želite spremembo velikosti predala iz ${prvotnoIzbranaVelikost}GB na ${izbranaVelikostiPredala}GB?`"
                                  >
                                    SPREMENI VELIKOST
                                  </OrderButton>
                                </div>
                              </template>
                          </div>
                          <el-form style="padding-top: 50px" label-width="150px":label-position="formaOrientacija">
                            <el-form-item label="Novo geslo:">
                              <el-input placeholder="" v-model="novoGeslo"
                                        value="FakePSW"
                                        id="novo-geslo" type="password" class="velikost-inputa-geslo">
                                <i slot="suffix" class="fa fa-eye-slash"
                                   id="ikonaEyeSlashNovoGeslo"
                                   @click="PrikazGeslaDodajanjePostniPredal('novo-geslo')"
                                   v-if="prikazeIkonoGeslo">
                                </i>
                                <i slot="suffix" class="fa fa-eye" id="ikonaEyeNovoGeslo"
                                   @click="PrikazGeslaDodajanjePostniPredal('novo-geslo')"
                                   v-else>
                                </i>
                              </el-input>
                            </el-form-item>
                            <el-form-item label="Potrdite novo geslo:">
                              <el-input placeholder=""
                                        v-model="potrjenoGeslo" value="FakePSW"
                                        id="novo-geslo2" type="password" class="velikost-inputa-geslo">
                                <i slot="suffix" class="fa fa-eye-slash"
                                   id="ikonaEyeSlashPonoviteGeslo"
                                   @click="PrikazGeslaDodajanjePostniPredal('novo-geslo2')"
                                   v-if="prikazeIkonoPonoviteGeslo">
                                </i>
                                <i slot="suffix" class="fa fa-eye"
                                   id="ikonaEyePonoviteGeslo"
                                   @click="PrikazGeslaDodajanjePostniPredal('novo-geslo2')"
                                   v-else>
                                </i>
                              </el-input>
                            </el-form-item>
                            </el-form>
                            <div style="padding-top: 10px">
                              <el-button type="primary"
                                         @click="GetShraniNovoGeslo(mailZaUrejanjeObj.ldap.mail)"
                                         class="gumb-potrdi">
                                SHRANI SPREMEMBE
                              </el-button>
                            </div>
                          </div>
                          <div style="clear: both; align-self: flex-end; height: 210px">
                            <div style="padding-bottom: 20px">
                              <div style="padding-top: 50px">
                                <div style="float: left">
                                  <img
                                    src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png">
                                </div>
                              </div>
                              <OrderButton
                                v-if="mailZaUrejanjeObj !== null"
                                :custom-notify-text="`${removeMailText} <br/> ${mailZaUrejanjeObj.ldap.mail}? <br/> ${removeMailWarning}`"
                                custom-notify-text-button-remove="Da, izbriši predal"
                                :services="[{
                                serviceId: StoritevEnum.DODATEN_1GB_EMAIL,
                                quantity: 0,
                                terminationPointId: Number.parseInt(izbranPrikljucek),
                                 additionalData: [
                                   {
                                     key: 'email',
                                     value: mailZaUrejanjeObj.ldap.mail
                                   }
                                 ]
                               }]"
                                  class="postavitev-gumb-narocanje"
                                :service-name="`email predal ${mailZaUrejanjeObj.ldap.mail}`"
                                  :only-modify-free-service="prvotnoIzbranaVelikost <= 1 && EmailOnPrimaryDomain(scope.row)"
                                  @modifyFreeService="GetOdstraniPostniPredal(scope.row.email)"
                                  @orderConfirmed="GetEmaili(); $emit('refreshTab')">
                                <template v-slot:buttonOverride>
                                    <div style="padding-left: 20px; padding-top: 2px">
                                      <div>
                                        <a class="open-sans-13pt">
                                          ODSTRANI POŠTNI PREDAL
                                        </a>
                                      </div>
                                    </div>
                                  </template>
                                </OrderButton>
                              <div>
                                <div style="padding-top: 20px">
                                  <p>
                                    <b class="primarna-barva-pisave">
                                      POZOR:
                                    </b>
                                  </p>
                                  <p class="primarna-barva-pisave">
                                    Če odstranite predal, bodo izbrisana tudi vsa
                                    sporočila, ki se nahajajo v njem. Priporočamo, da
                                    pred odstranitvijo ustvarite varnostno kopijo.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                      <div v-if="scope.row.nePrikazeGumba !== true" style="padding-top: 20px">
                        <p style="text-align: center" class="navadno-besedilo">
                          Ni možno urejati maila
                        </p>
                      </div>
                    </template>
                  </el-table-column>
              </t2-table>
          </div>
        </span>
        <span v-show="prikazTabele === '0'" v-if="seznamT2Domen.length > 0" v-loading="nalaganjeTabeleMeilov">
          <div style="padding-top: 40px">
            <div>
              <p class="open-sans-20pt">
                E-predal s t-2 domeno
              </p>
            </div>
            <div style="display: flex; flex-direction: column" class="pt-3 pb-3" v-if="this.izbranPrikljucek !== null">
              <div>
                Domena:
                <b class="primarna-barva">
                  @t-2.net, @t-2.si
                </b>
              </div>
              <div>
                Število ustvarjenih predalov:
                <b class="primarna-barva">
                  {{ seznamEmailov.filter(x => this.validacija.JeT2Domena(x.email)).length }}
                </b>
              </div>
            </div>
            <t2-table
              :rows-per-page="5"
              class="predali"
              :data="seznamT2Domen"
              style="width: 100%"
              @expand-change="Izbranavrstica"
              :expand-row-keys="expandRowKeys"
              :row-key="row => row.email">
                <el-table-column
                  class="crna"
                  label="E-predal">
                    <template slot-scope="scope">
                      {{ scope.row.email }}
                    </template>
                </el-table-column>
                <el-table-column
                  align="right" min-width="10">
                    <template slot-scope="scope">
                      <span v-if="scope.row.podatekSn === ''">
                        <el-icon class="el-icon-warning" style="color: red; font-size: 20px"></el-icon>
                        Predal ni v LDAP-u in ne deluje.
                      </span>
                    </template>
                </el-table-column>
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <div style="width: auto; margin: auto; padding-bottom: 60px;"
                       v-if="scope.row.nePrikazeGumba !== false"
                       v-loading="nalaganjeInfoPredala">
                    <div class="notranji-odmik">
                      <div class="notranja-postavitev">
                        <p style="font-size: 14px">
                          <b>
                            Psevdonimi
                            <PsevdonimTooltip/>
                          </b>
                        </p>
                        <div>
                          <div class="postavitev-izbran-postni-predal">
                            <p class="Text-Style">
                              Izbran poštni predal:
                            </p>
                          </div>
                          <div class="postavitev-izpisan-postni-predal">
                            <p class="primarna-barva">
                              {{ scope.row.email }}
                            </p>
                          </div>
                        </div>
                        <div v-if="seznamNovihKreiranihEmailov.length > 0">
                          <div class="postavitev-psevdonimi">
                            <p class="primarna-barva-pisave">
                              Psevdonimi:
                            </p>
                          </div>
                          <div class="postavitev-izpis-psevdonimi">
                            <table v-loading="nalaganjePsevdonimov">
                              <tr v-for="(data,index) in seznamNovihKreiranihEmailov"
                                  :key="index" style="border: 1px;">
                                <td class="stil-tabela-psevdonimi">
                                  <div style="float: left">
                                    <img
                                      src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png"
                                      @click="OdstraniPsevdonim
                                           (mailZaUrejanjeObj.ldap.mail, data)"
                                      style="padding-right: 10px; cursor: pointer">
                                  </div>
                                  <span class="stil-tabela-psevdonimi">
                                    {{ data }}
                                  </span>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <br style="clear: both"/>
                        <el-form style="padding-top: 30px" label-width="150px" :label-position="formaOrientacija">
                          <el-form-item label="Nov psevdonim">
                            <el-input placeholder="" v-model="novPsevdonim" class="velikost-inputa-psevdonim">
                            </el-input>
                            <span class="postavitev-afne">
                              <b style="padding: 0 10px 0;">
                                @
                              </b>
                            </span>
                            <el-select v-model="izbranaT2Domena" placeholder="Izberi" class="velikost-inputa-domene">
                              <el-option
                                v-for="data in t2Domene"
                                :key="data"
                                :label="data"
                                :value="data">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                        <div style="padding-top: 10px">
                          <el-button @click="DodajNovPsevdonim(mailZaUrejanjeObj.ldap.mail, izbranaT2Domena)"
                                     class="tekst-gumba-dodajanje okvir-gumba-dodajanje
                                      velikost-gumba-psevdonim">
                            USTVARI PSEVDONIM
                          </el-button>
                        </div>
                        <div class="odmik-povecaj-postni-predal" style="margin-bottom: 20px;" v-loading="loadingGetSpremembaQote">
                          <p class="open-sans-14pt-bold krepko">
                            Velikost poštnega predala
                          </p>
                          <p>
                            Naročena velikost predala:
                            <b>
                              {{ velikostPredala }}
                            </b>
                          </p>
                          <p>
                            Zasedenost poštnega predala:
                            <b>
                              {{ zasedenProstor }}
                            </b>
                          </p>
                            <template v-if="mailZaUrejanjeObjPravicaUrejanja && mailZaUrejanjeObj !== null">
                              <div style="padding-top: 10px" class="mobile-label"/>
                              <div style="line-height: 40px;">
                                Spremeni velikost poštnega predala na
                                <el-select v-model="izbranaVelikostiPredala"
                                           placeholder="Izberi" class="input-povecaj-postni-predal">
                                  <el-option
                                    v-for="data in seznamMoznihVelikosti"
                                    :key="data"
                                    :label="`${data}.00 GB`"
                                    :value="data">
                                  </el-option>
                                </el-select>
                                <a :href="povezavaAdministrativneStoritveZasebno"
                                   target="_blank" class="primarna-barva povezava-administrativne-storitve">
                                   Cenik storitev
                                </a>
                              </div>
                              <div class="pt-2 mb-7">
                                <OrderButton
                                  v-if="mailZaUrejanjeObj !== null"
                                  :disabled="prvotnoIzbranaVelikost === izbranaVelikostiPredala"
                                  :services="[{
                                      serviceId: StoritevEnum.DODATEN_1GB_EMAIL,
                                      quantity: Number(izbranaVelikostiPredala),
                                      terminationPointId: Number.parseInt(izbranPrikljucek),
                                       additionalData: [
                                        {
                                          key: 'email',
                                          value: mailZaUrejanjeObj.ldap.mail
                                        }
                                      ]
                                  }]"
                                  class="postavitev-gumb-narocanje"
                                  style="max-width: 177px"
                                  service-name=""
                                  custom-notify-text-button="Da, spremeni velikost"
                                  :custom-notify-text="`Ste prepričani, da želite spremembo velikosti predala iz ${prvotnoIzbranaVelikost}GB na ${izbranaVelikostiPredala}GB?`"
                                  @orderConfirmed="GetPrikaziNastavitve(mailZaUrejanjeObj.ldap.mail); GetEmaili()">
                                  SPREMENI VELIKOST
                                </OrderButton>
                              </div>
                            </template>
                        </div>
                        <div>
                          <div>
                            <p>
                              <b class="primarna-barva-pisave">
                                POZOR:
                              </b>
                            </p>
                            <p class="primarna-barva-pisave">
                              Če odstranite predal, bodo izbrisana tudi vsa
                              sporočila, ki se nahajajo v njem. Priporočamo, da
                              pred odstranitvijo ustvarite varnostno kopijo.
                            </p>
                          </div>
                        </div>
                        <el-form style="padding-top: 50px" label-width="150px":label-position="formaOrientacija">
                          <el-form-item label="Novo geslo:">
                            <el-input placeholder="" v-model="novoGeslo"
                                      value="FakePSW"
                                      id="novo-geslo" type="password" class="velikost-inputa-geslo">
                              <i slot="suffix" class="fa fa-eye-slash"
                                 id="ikonaEyeSlashNovoGeslo"
                                 @click="PrikazGeslaDodajanjePostniPredal('novo-geslo')"
                                 v-if="prikazeIkonoGeslo">
                              </i>
                              <i slot="suffix" class="fa fa-eye" id="ikonaEyeNovoGeslo"
                                 @click="PrikazGeslaDodajanjePostniPredal('novo-geslo')"
                                 v-else>
                              </i>
                            </el-input>
                          </el-form-item>
                          <el-form-item label="Potrdite novo geslo:">
                            <el-input placeholder=""
                                      v-model="potrjenoGeslo" value="FakePSW"
                                      id="novo-geslo2" type="password" class="velikost-inputa-geslo">
                              <i slot="suffix" class="fa fa-eye-slash"
                                 id="ikonaEyeSlashPonoviteGeslo"
                                 @click="PrikazGeslaDodajanjePostniPredal('novo-geslo2')"
                                 v-if="prikazeIkonoPonoviteGeslo">
                              </i>
                              <i slot="suffix" class="fa fa-eye"
                                 id="ikonaEyePonoviteGeslo"
                                 @click="PrikazGeslaDodajanjePostniPredal('novo-geslo2')"
                                 v-else>
                              </i>
                            </el-input>
                          </el-form-item>
                        </el-form>
                        <div style="padding-top: 10px">
                          <el-button type="primary"
                                     @click="GetShraniNovoGeslo(mailZaUrejanjeObj.ldap.mail)"
                                     class="gumb-potrdi">
                            SHRANI SPREMEMBE
                          </el-button>
                        </div>
                        <div class="odmik-odstrani-postni-predal">
                          <OrderButton
                            v-if="mailZaUrejanjeObj !== null"
                            :custom-notify-text="`${removeMailText} <br/> ${mailZaUrejanjeObj.ldap.mail}? <br/> ${removeMailWarning}`"
                            custom-notify-text-button-remove="Da, izbriši predal"
                            :services="[{
                               serviceId: StoritevEnum.DODATEN_1GB_EMAIL,
                               quantity: 0,
                               terminationPointId: Number.parseInt(izbranPrikljucek),
                                additionalData: [
                                  {
                                    key: 'email',
                                    value: mailZaUrejanjeObj.ldap.mail
                                  }
                                ]
                              }]"
                            class="postavitev-gumb-narocanje"
                            :service-name="`email predal ${mailZaUrejanjeObj.ldap.mail}`"
                            :only-modify-free-service="prvotnoIzbranaVelikost <= 1 && EmailOnPrimaryDomain(scope.row)"
                            @modifyFreeService="GetOdstraniPostniPredal(scope.row.email)"
                            @orderConfirmed="GetEmaili(); $emit('refreshTab')">
                            <template v-slot:buttonOverride>
                              <el-button
                                class="tekst-gumba-dodajanje okvir-gumba-dodajanje velikost-gumba-odstrani-predal">
                                ODSTRANI POŠTNI PREDAL
                              </el-button>
                            </template>
                          </OrderButton>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="scope.row.nePrikazeGumba !== true" style="padding-top: 20px">
                    <p style="text-align: center">
                      Ni možno urejati maila
                    </p>
                  </div>
                </template>
              </el-table-column>
            </t2-table>
          </div>
        </span>
        <br/>
        <div v-if="seznamOstalihDomen.length > 0">
          <div>
            <hr class="hr-stil">
          </div>
          <div class="mt-9">
            <p class="open-sans-20pt">
              E-predal z lastno domeno
            </p>
          </div>
          <div>
            <div v-for="(domena ,imeDomene) in PredaliNaLastnihDomenah">
              <div class="flex-container flex-row-data pt-3 pb-3" v-if="izbranPrikljucek !== null">
                <div>
                  Domena:
                  <b class="primarna-barva">
                    {{imeDomene}}
                  </b>
                </div>
                <div>
                  Število ustvarjenih predalov:
                  <b class="primarna-barva">
                    {{ domena.predali.length }}
                  </b>
                </div>
              </div>
              <t2-table
                :data="domena.predali" v-loading="nalaganjeTabeleMeilov"
                style="width: 100%; padding-bottom: 30px"
                @expand-change="IzbranavrsticaLastnaDomena"
                :expand-row-keys="expandRowKeys"
                :row-key="row => row.email"
                :rows-per-page="5"
              >
                <el-table-column sortable :sort-method="sortByPredal" label="E-predal">
                  <template slot-scope="scope">
                    {{ scope.row.email }}
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="prikazTabele === '1'"
                  label="Naziv za prikaz"
                  prop="podatekSn">
                  <template slot-scope="scope">
                    <span v-if="scope.row.podatekSn === ''">
                       <el-icon class="el-icon-warning" style="color: red; font-size: 20px"></el-icon>
                      Predal ni v LDAP-u in ne deluje.
                    </span>
                    <span v-else>
                      {{ scope.row.podatekSn }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column v-if="prikazTabele === '1'" label="Datum kreiranja" sortable :sort-method="sortByDate">
                  <template slot-scope="scope">
                    {{ (scope.row.kreiran).slice(0, 10) }}
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="prikazTabele === '1'"
                  label="Velikost">
                  <template slot-scope="scope">
                    <span v-if="scope.row.ldap !== null">
                      <p class="crna">
                        {{ `${scope.row.ldap.mailquota}B`}}
                      </p>
                    </span>
                    <span v-else>
                     /
                    </span>
                  </template>
                </el-table-column>
                <el-table-column type="expand">
                  <template slot-scope="scope">
                    <div style="width: auto; margin: auto; padding-bottom: 60px;"
                         v-if="scope.row.nePrikazeGumba !== false" v-loading="nalaganjeInfoPredala">
                      <div class="notranji-odmik">
                        <div class="container">
                          <div class="notranja-postavitev">
                            <p style="font-size: 14px;">
                              <b>
                                Psevdonimi
                                <PsevdonimTooltip/>
                              </b>
                            </p>
                            <div class="prikaz-mobile">
                              <div>
                                <p class="Text-Style odmik-label">
                                  Izbran poštni predal:
                                </p>
                              </div>
                              <div>
                                <p class="primarna-barva">
                                  {{ scope.row.email }}
                                </p>
                              </div>
                            </div>
                            <div class="prikaz-mobile" v-if="seznamNovihKreiranihEmailov.length > 0">
                              <div>
                                <p class="primarna-barva-pisave odmik-label">
                                  Psevdonimi:
                                </p>
                              </div>
                              <div>
                                <table v-loading="nalaganjePsevdonimov">
                                  <tr v-for="(data,index) in seznamNovihKreiranihEmailov"
                                      :key="index" style="border: 1px;">
                                    <td class="stil-tabela-psevdonimi">
                                      <div style="float: left">
                                        <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png"
                                             @click="OdstraniPsevdonim(mailZaUrejanjeObj.ldap.mail, data)"
                                             style="padding-right: 10px; cursor: pointer">
                                      </div>
                                      <td class="stil-tabela-psevdonimi">
                                        {{ data }}
                                      </td>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                            <br style="clear: both"/>
                            <el-form style="padding-top: 30px" label-width="150px" :label-position="formaOrientacija">
                              <el-form-item label="Nov psevdonim">
                                <el-input placeholder="" v-model="novPsevdonim" class="velikost-inputa-psevdonim">
                                </el-input>
                                <span class="postavitev-afne">
                                  <b style="padding: 0 10px 0;">
                                    @
                                  </b>
                                </span>
                                <el-select v-model="izbranaLastnaDomena"
                                           placeholder="Izberi"
                                           class="velikost-inputa-domene">
                                  <el-option
                                    v-for="data in lastneDomene"
                                    :key="data"
                                    :label="data"
                                    :value="data">
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-form>
                            <div style="padding-top: 20px">
                              <el-button
                                @click="DodajNovPsevdonim(mailZaUrejanjeObj.ldap.mail, izbranaLastnaDomena)"
                                class="tekst-gumba-dodajanje okvir-gumba-dodajanje velikost-gumba-psevdonim">
                                USTVARI PSEVDONIM
                              </el-button>
                            </div>
                            <div class="odmik-povecaj-postni-predal" v-loading="loadingGetSpremembaQote">
                              <p class="open-sans-14pt-bold krepko">
                                Velikost poštnega predala
                              </p>
                              <p>
                                Naročena velikost predala:
                                <b>
                                  {{ velikostPredala }}
                                </b>
                              </p>
                              <p>
                                Zasedenost poštnega predala:
                                <b>
                                  {{ zasedenProstor }}
                                </b>
                              </p>
                              <template v-if="mailZaUrejanjeObjPravicaUrejanja">
                                <div style="padding-top: 10px" class="mobile-label"/>
                                <div style="line-height: 40px;">
                                  Spremeni velikost poštnega predala na
                                  <el-select v-model="izbranaVelikostiPredala"
                                             placeholder="Izberi" class="input-povecaj-postni-predal">
                                    <el-option
                                      v-for="data in seznamMoznihVelikosti"
                                      :key="data"
                                      :label="`${data}.00 GB`"y
                                      :value="data">
                                    </el-option>
                                  </el-select>
                                  <a :href="povezavaAdministrativneStoritveZasebno"
                                     target="_blank" class="primarna-barva povezava-administrativne-storitve">
                                    Cenik storitev
                                  </a>
                                </div>
                                <div class="pt-2 mb-7">
                                  <OrderButton
                                    v-if="mailZaUrejanjeObj !== null"
                                    :disabled="prvotnoIzbranaVelikost === izbranaVelikostiPredala"
                                    :services="[{
                                        serviceId: StoritevEnum.DODATEN_1GB_EMAIL,
                                        quantity: Number(izbranaVelikostiPredala),
                                        terminationPointId: Number.parseInt(izbranPrikljucek),
                                         additionalData: [
                                          {
                                            key: 'email',
                                            value: mailZaUrejanjeObj.ldap.mail
                                          }
                                        ]
                                    }]"
                                    class="postavitev-gumb-narocanje"
                                    style="max-width: 177px"
                                    custom-notify-text-button="Da, spremeni velikost"
                                    :custom-notify-text="`Ste prepričani, da želite spremembo velikosti predala iz ${prvotnoIzbranaVelikost}GB na ${izbranaVelikostiPredala}GB?`"
                                    service-name=""
                                    @orderConfirmed="GetPrikaziNastavitve(mailZaUrejanjeObj.ldap.mail); GetEmaili()">
                                    SPREMENI VELIKOST
                                  </OrderButton>
                                </div>
                              </template>
                            </div>
                            <div v-if="prikazTabele === '0'">
                              <div>
                                <p>
                                  <b class="primarna-barva-pisave">
                                    POZOR:
                                  </b>
                                </p>
                                <p class="primarna-barva-pisave">
                                  Če odstranite predal, bodo izbrisana tudi vsa
                                  sporočila, ki se nahajajo v njem. Priporočamo, da
                                  pred odstranitvijo ustvarite varnostno kopijo.
                                </p>
                              </div>
                            </div>
                            <el-form style="padding-top: 50px">
                              <el-form-item label="Novo geslo:">
                                <el-input placeholder="" v-model="novoGeslo"
                                          value="FakePSW"
                                          class="velikost-inputa-geslo left-odmik"
                                          id="novo-geslo" type="password">
                                  <i slot="suffix" class="fa fa-eye-slash"
                                     id="ikonaEyeSlashNovoGeslo"
                                     @click="PrikazGeslaDodajanjePostniPredal('novo-geslo')"
                                     v-if="prikazeIkonoGeslo">
                                  </i>
                                  <i slot="suffix" class="fa fa-eye"
                                     id="ikonaEyeNovoGeslo"
                                     @click="PrikazGeslaDodajanjePostniPredal('novo-geslo')"
                                     v-else>
                                  </i>
                                </el-input>
                              </el-form-item>
                              <el-form-item label="Potrdite novo geslo:">
                                <el-input placeholder=""
                                          v-model="potrjenoGeslo" value="FakePSW"
                                          id="novo-geslo2" type="password"
                                          class="velikost-inputa-geslo">
                                  <i slot="suffix" class="fa fa-eye-slash"
                                     id="ikonaEyeSlashPonoviteGeslo"
                                     @click="PrikazGeslaDodajanjePostniPredal('novo-geslo2')"
                                     v-if="prikazeIkonoPonoviteGeslo">
                                  </i>
                                  <i slot="suffix" class="fa fa-eye"
                                     id="ikonaEyePonoviteGeslo"
                                     @click="PrikazGeslaDodajanjePostniPredal('novo-geslo2')"
                                     v-else>
                                  </i>
                                </el-input>
                              </el-form-item>
                            </el-form>
                            <div style="padding-top: 10px">
                              <el-button type="primary"
                                         @click="GetShraniNovoGeslo(mailZaUrejanjeObj.ldap.mail)"
                                         class="gumb-potrdi">
                                SHRANI SPREMEMBE
                              </el-button>
                            </div>
                            <div class="odmik-odstrani-postni-predal" v-if="prikazTabele === '0'">
                              <OrderButton
                                v-if="mailZaUrejanjeObj !== null"
                                :custom-notify-text="`${removeMailText} <br/> ${mailZaUrejanjeObj.ldap.mail}? <br/> ${removeMailWarning}`"
                                custom-notify-text-button-remove="Da, izbriši predal"
                                :services="[{
                               serviceId: StoritevEnum.DODATEN_1GB_EMAIL,
                               quantity: 0,
                               terminationPointId: Number.parseInt(izbranPrikljucek),
                                additionalData: [
                                  {
                                    key: 'email',
                                    value: mailZaUrejanjeObj.ldap.mail
                                  }
                                ]
                              }]"
                                class="postavitev-gumb-narocanje"
                                :service-name="`email predal ${mailZaUrejanjeObj.ldap.mail}`"
                                :only-modify-free-service="prvotnoIzbranaVelikost <= 1 && EmailOnPrimaryDomain(scope.row)"
                                @modifyFreeService="GetOdstraniPostniPredal(scope.row.email)"
                                @orderConfirmed="GetEmaili(); $emit('refreshTab')">
                                <template v-slot:buttonOverride>
                                  <el-button class="tekst-gumba-dodajanje okvir-gumba-dodajanje velikost-gumba-odstrani-predal">
                                    ODSTRANI POŠTNI PREDAL
                                  </el-button>
                                </template>
                              </OrderButton>
                            </div>
                          </div>
                          <div style="clear: both; align-self: flex-end;" v-if="prikazTabele === '1'">
                            <div style="padding-bottom: 20px">
                              <div style="padding-top: 50px">
                                <div style="float: left; cursor: pointer">
                                  <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png">
                                </div>
                              </div>
                              <div style="padding-left: 20px; padding-top: 2px">
                                <div>
                                  <OrderButton
                                    v-if="mailZaUrejanjeObj !== null"
                                    :custom-notify-text="`${removeMailText} <br/> ${mailZaUrejanjeObj.ldap.mail}? <br/> ${removeMailWarning}`"
                                    custom-notify-text-button-remove="Da, izbriši predal"
                                    :services="[{
                                  serviceId: StoritevEnum.DODATEN_1GB_EMAIL,
                                  quantity: 0,
                                  terminationPointId: Number.parseInt(izbranPrikljucek),
                                   additionalData: [
                                     {
                                       key: 'email',
                                       value: mailZaUrejanjeObj.ldap.mail
                                     }
                                   ]
                                 }]"
                                    class="postavitev-gumb-narocanje"
                                    :service-name="`email predal ${mailZaUrejanjeObj.ldap.mail}`"
                                    :only-modify-free-service="prvotnoIzbranaVelikost <= 1 && EmailOnPrimaryDomain(scope.row)"
                                    @modifyFreeService="GetOdstraniPostniPredal(scope.row.email)"
                                    @orderConfirmed="GetEmaili(); $emit('refreshTab')">
                                    <template v-slot:buttonOverride>
                                      <div style="padding-left: 20px; padding-top: 2px">
                                        <div>
                                          <a class="open-sans-13pt">
                                            ODSTRANI POŠTNI PREDAL
                                          </a>
                                        </div>
                                      </div>
                                    </template>
                                  </OrderButton>
                                </div>
                              </div>
                              <div>
                                <div style="padding-top: 20px">
                                  <p>
                                    <b class="primarna-barva-pisave">
                                      POZOR:
                                    </b>
                                  </p>
                                  <p class="primarna-barva-pisave">
                                    Če odstranite predal, bodo izbrisana tudi vsa
                                    sporočila, ki se nahajajo v njem. Priporočamo, da
                                    pred odstranitvijo ustvarite varnostno kopijo.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="scope.row.nePrikazeGumba !== true" style="padding-top: 20px">
                      <p style="text-align: center" class="navadno-besedilo">
                        Ni možno urejati maila
                      </p>
                    </div>
                  </template>
                </el-table-column>
              </t2-table>
            </div>
          </div>
        </div>
        <div v-if="seznamDomainList.length > 0">
          <div>
            <hr class="hr-stil">
          </div>
          <div style="padding-top: 40px">
            <p class="open-sans-20pt">
              Domain list
            </p>
          </div>
          <div style="padding-top: 30px">
            <t2-table :data="seznamDomainList"
                      @expand-change="IzbranavrsticaDomainList"
                      :expand-row-keys="expandRowKeys"
                      :row-key="row => row.email">
              <el-table-column
                label="E-predal"
                prop="email">
              </el-table-column>
              <el-table-column
                label="Datum kreiranja"
                prop="kreiran">
              </el-table-column>
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <div style="padding-top: 30px">
                    <div class="container">
                      <div class="notranja-postavitev">
                        <div style="padding-top: 20px">
                          Domainlist naslov:
                          <span style="color: #f58220">
                              {{ scope.row.email }}
                          </span>
                        </div>
                        <div style="padding-top: 30px">
                          <p class="navadno-besedilo">
                            <b>
                              Obstoječim vpišite dodatne e-naslove, ki jih želite vključiti:
                            </b>
                          </p>
                        </div>
                        <div class="odmik-dodajanje-predala">
                          <div class="form-group" v-for="(input,i) in inputs" :key="i">
                            <div>
                              <el-input placeholder="" type="text" class="velikost-vnosnega-polja"
                                        v-model="input.email">
                              </el-input>
                              <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg" @click="remove(i)"
                                   style="cursor: pointer">
                            </div>
                          </div>
                        </div>
                        <div>
                          <a class="navadno-besedilo primarna-barva" @click="add()" style="cursor: pointer">
                            + Dodaj naslov
                          </a>
                        </div>
                        <div style="padding-top: 35px">
                          <div>
                            <el-button type="primary" class="gumb-potrdi" @click="UpdateDomainlist(scope.row.email)">
                              SHRANI SPREMEMBE
                            </el-button>
                          </div>
                        </div>
                      </div>
                      <div style="clear: both; align-self: flex-end;">
                        <div style="padding-bottom: 20px">
                          <div style="padding-top: 50px">
                            <div style="float: left">
                              <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png">
                            </div>
                          </div>
                          <OrderButton
                            v-if="mailZaUrejanjeObj !== null"
                            :custom-notify-text="`${removeMailText} <br/> ${mailZaUrejanjeObj.ldap.mail}? <br/> ${removeMailWarning}`"
                            custom-notify-text-button-remove="Da, izbriši predal"
                            :services="[{
                                serviceId: StoritevEnum.DODATEN_1GB_EMAIL,
                                quantity: 0,
                                terminationPointId: Number.parseInt(izbranPrikljucek),
                                 additionalData: [
                                   {
                                     key: 'email',
                                     value: mailZaUrejanjeObj.ldap.mail
                                   }
                                 ]
                               }]"
                            class="postavitev-gumb-narocanje"
                            :service-name="`email predal ${mailZaUrejanjeObj.ldap.mail}`"
                            :only-modify-free-service="prvotnoIzbranaVelikost <= 1 && EmailOnPrimaryDomain(scope.row)"
                            @modifyFreeService="GetOdstraniPostniPredal(scope.row.email)"
                            @orderConfirmed="GetEmaili(); $emit('refreshTab')">
                            <template v-slot:buttonOverride>
                              <div style="padding-left: 20px; padding-top: 2px">
                                <div>
                                  <a class="open-sans-13pt">
                                    ODSTRANI POŠTNI PREDAL
                                  </a>
                                </div>
                              </div>
                            </template>
                          </OrderButton>
                          <div>
                            <div style="padding-top: 20px">
                              <p>
                                <b class="primarna-barva-pisave">
                                  POZOR:
                                </b>
                              </p>
                              <p class="primarna-barva-pisave">
                                Priporočamo, da pred odstranitvijo ustvarite varnostno kopijo.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </t2-table>
          </div>
        </div>
        <div v-if="dodeljeniEmaili.length > 0" v-loading="nalaganjeTabeleMeilov" style="padding-top: 40px">
          <div>
            <p class="open-sans-20pt">
              E-predali, ki so vam jih delili drugi uporabniki
            </p>
          </div>
          <el-table
            class="predali"
            header-row-class-name="glava-tabela"
            :data="dodeljeniEmaili"
            style="width: 100%; padding-top: 20px"
            :expand-row-keys="expandRowKeys"
            :row-key="row => row.email"
            @expand-change="Izbranavrstica">
            <el-table-column
              label="E-predal" :sort-method="sortByPredal" sortable>
              <template slot-scope="scope">
                {{ scope.row.email }}
              </template>
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div class="" style="width: auto; margin: auto; padding-bottom: 30px"
                     v-loading="nalaganjeInfoPredala">
                  <div class="notranji-odmik" v-if="nalaganjeInfoPredala === false && mailZaUrejanjeObj !== null">
                    <div class="container">
                      <div class="notranja-postavitev">
                        <p style="font-size: 14px">
                          <b>
                            Psevdonimi
                            <el-tooltip class="item primarna-barva" popper-class="psevdonimi"
                                        content="Elektronskemu naslovu lahko dodate želene
                                            psevdonime (aliase), katere poimenujete po svoji želji
                                            (na primer:janez_novak@t-2.net, janez.novak@t-2.net,
                                            janez_t@t-2.net itd.).Elektronsko pošto naslovljeno na
                                            katerikoli e-poštni psevdonim boste prejemali v vaš
                                            elektronski predal. " placement="bottom">
                              <el-icon class="el-icon-info"></el-icon>
                            </el-tooltip>
                          </b>
                        </p>
                        <div class="prikaz-mobile">
                          <div class="odmik-label">
                            <p class="Text-Style">
                              Izbran poštni predal:
                            </p>
                          </div>
                          <div>
                            <p class="primarna-barva krepko crna">
                              {{ mailZaUrejanjeObj.ldap.mail }}
                            </p>
                          </div>
                        </div>
                        <div class="prikaz-mobile" v-if="seznamNovihKreiranihEmailov.length > 0">
                          <div>
                            <p class="primarna-barva-pisave odmik-label">
                              Psevdonimi:
                            </p>
                          </div>
                          <div>
                            <table v-loading="nalaganjePsevdonimov">
                              <tr v-for="(data,index) in seznamNovihKreiranihEmailov" :key="index" style="border: 1px;">
                                <td class="stil-tabela-psevdonimi">
                                  <div style="float: left">
                                    <img
                                      src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png"
                                      @click="OdstraniPsevdonim
                                                 (mailZaUrejanjeObj.ldap.mail, data)"
                                      style="padding-right: 10px; cursor: pointer">
                                  </div>
                                  <span class="krepko crna stil-tabela-psevdonimi">
                                    {{ data }}
                                  </span>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <br style="clear: both"/>
                        <el-form style="padding-top: 30px" label-width="150px" :label-position="formaOrientacija">
                          <el-form-item label="Nov psevdonim">
                            <el-input placeholder="" v-model="novPsevdonim" class="velikost-inputa-psevdonim">
                            </el-input>
                            <span class="postavitev-afne">
                                <b style="padding: 0 10px 0;">
                                  @
                                </b>
                              </span>
                            <el-select v-model="izbranaT2Domena" placeholder="Izberi" class="velikost-inputa-domene">
                              <el-option
                                v-for="data in mailZaUrejanjeObj.domene"
                                :key="data"
                                :label="data"
                                :value="data">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                        <div style="padding-top: 18px">
                          <el-button @click="DodajNovPsevdonim(mailZaUrejanjeObj.ldap.mail, izbranaT2Domena)"
                                     class="tekst-gumba-dodajanje okvir-gumba-dodajanje
                                      velikost-gumba-psevdonim">
                            USTVARI PSEVDONIM
                          </el-button>
                        </div>
                        <div class="odmik-povecaj-postni-predal">
                          <p class="open-sans-14pt-bold krepko">
                            Velikost poštnega predala
                          </p>
                          <p>
                            Naročena velikost predala:
                            <b>
                              {{ velikostPredala }}
                            </b>
                          </p>
                          <p>
                            Zasedenost poštnega predala:
                            <b>
                              {{ zasedenProstor }}
                            </b>
                          </p>
                          <template v-if="mailZaUrejanjeObjPravicaUrejanja && mailZaUrejanjeObj !== null">
                            <div style="padding-top: 10px" class="mobile-label" />
                            <div style="line-height: 40px;">
                              Spremeni velikost poštnega predala na
                              <el-select v-model="izbranaVelikostiPredala"
                                         placeholder="Izberi" class="input-povecaj-postni-predal">
                                <el-option
                                  v-for="data in seznamMoznihVelikosti"
                                  :key="data"
                                  :label="data"
                                  :value="data">
                                </el-option>
                              </el-select>
                              <a :href="povezavaAdministrativneStoritveZasebno"
                                 target="_blank" class="primarna-barva povezava-administrativne-storitve">
                                Cenik storitev
                              </a>
                            </div>
                            <div class="pt-2 mb-7">
                              <OrderButton
                                v-if="mailZaUrejanjeObj !== null"
                                :disabled="prvotnoIzbranaVelikost === izbranaVelikostiPredala"
                                :services="[{
                                        serviceId: StoritevEnum.DODATEN_1GB_EMAIL,
                                        quantity: Number(izbranaVelikostiPredala),
                                        terminationPointId: Number.parseInt(izbranPrikljucek),
                                         additionalData: [
                                          {
                                            key: 'email',
                                            value: mailZaUrejanjeObj.ldap.mail
                                          }
                                        ]
                                    }]"
                                class="postavitev-gumb-narocanje"
                                style="max-width: 177px"
                                service-name=""
                                custom-notify-text-button="Da, spremeni velikost"
                                @orderConfirmed="GetPrikaziNastavitve(mailZaUrejanjeObj.ldap.mail); GetEmaili()"
                                :custom-notify-text="`Ste prepričani, da želite spremembo velikosti predala iz ${prvotnoIzbranaVelikost}GB na ${izbranaVelikostiPredala}GB?`"
                              >
                                SPREMENI VELIKOST
                              </OrderButton>
                            </div>
                          </template>
                        </div>
                        <el-form style="padding-top: 50px" label-width="150px" :label-position="formaOrientacija">
                          <el-form-item label="Novo geslo:">
                            <el-input placeholder="" v-model="novoGeslo"
                                      value="FakePSW"
                                      id="novo-geslo" type="password" class="velikost-inputa-geslo">
                              <i slot="suffix" class="fa fa-eye-slash"
                                 id="ikonaEyeSlashNovoGeslo"
                                 @click="PrikazGeslaDodajanjePostniPredal('novo-geslo')"
                                 v-if="prikazeIkonoGeslo">
                              </i>
                              <i slot="suffix" class="fa fa-eye" id="ikonaEyeNovoGeslo"
                                 @click="PrikazGeslaDodajanjePostniPredal('novo-geslo')"
                                 v-else>
                              </i>
                            </el-input>
                          </el-form-item>
                          <el-form-item label="Potrdite novo geslo:">
                            <el-input placeholder=""
                                      v-model="potrjenoGeslo" value="FakePSW"
                                      id="novo-geslo2" type="password" class="velikost-inputa-geslo">
                              <i slot="suffix" class="fa fa-eye-slash"
                                 id="ikonaEyeSlashPonoviteGeslo"
                                 @click="PrikazGeslaDodajanjePostniPredal('novo-geslo2')"
                                 v-if="prikazeIkonoPonoviteGeslo">
                              </i>
                              <i slot="suffix" class="fa fa-eye"
                                 id="ikonaEyePonoviteGeslo"
                                 @click="PrikazGeslaDodajanjePostniPredal('novo-geslo2')"
                                 v-else>
                              </i>
                            </el-input>
                          </el-form-item>
                        </el-form>
                        <div style="padding-top: 10px">
                          <el-button type="primary"
                                     @click="GetShraniNovoGeslo(mailZaUrejanjeObj.ldap.mail)"
                                     class="gumb-potrdi">
                            SHRANI SPREMEMBE
                          </el-button>
                        </div>
                      </div>
                      <div style="clear: both; align-self: flex-end;">
                        <div style="padding-bottom: 20px">
                          <div style="padding-top: 50px">
                            <div style="float: left">
                              <img
                                src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png">
                            </div>
                          </div>
                          <div style="padding-left: 20px; padding-top: 2px">
                            <div>
                              <OrderButton
                                v-if="mailZaUrejanjeObj !== null"
                                :service-name="`email predal ${mailZaUrejanjeObj.ldap.mail}`"
                                :custom-notify-text="`${removeMailText} <br/> ${mailZaUrejanjeObj.ldap.mail}? <br/> ${removeMailWarning}`"
                                custom-notify-text-button-remove="Da, izbriši predal"
                                :services="[{
                                serviceId: StoritevEnum.DODATEN_1GB_EMAIL,
                                quantity: 0,
                                terminationPointId: Number.parseInt(izbranPrikljucek),
                                 additionalData: [
                                   {
                                     key: 'email',
                                     value: mailZaUrejanjeObj.ldap.mail
                                   }
                                 ]
                               }]"
                                class="postavitev-gumb-narocanje"
                                :only-modify-free-service="prvotnoIzbranaVelikost <= 1 && EmailOnPrimaryDomain(scope.row)"
                                @modifyFreeService="GetOdstraniPostniPredal(scope.row.email)"
                                @orderConfirmed="GetDodeljeniEmaili(); $emit('refreshTab')">
                                <template v-slot:buttonOverride>
                                  <div style="padding-left: 20px; padding-top: 2px">
                                    <div>
                                      <a class="open-sans-13pt">
                                        ODSTRANI POŠTNI PREDAL
                                      </a>
                                    </div>
                                  </div>
                                </template>
                              </OrderButton>
                            </div>
                          </div>
                          <div>
                            <div style="padding-top: 20px">
                              <p>
                                <b class="primarna-barva-pisave">
                                  POZOR:
                                </b>
                              </p>
                              <p class="primarna-barva-pisave">
                                Če odstranite predal, bodo izbrisana tudi vsa
                                sporočila, ki se nahajajo v njem. Priporočamo, da
                                pred odstranitvijo ustvarite varnostno kopijo.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-else-if="nalaganjeTabeleMeilov === false">
        <KomponentaBrezEpredalov/>
      </div>
    </div>
  </div>
</template>
<script>
import {PretvorbaEnot} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PretvorbaEnotB.js'
import Validacija from 'src/assets/js/globalne_funkcije/Validacija.js'
import {KontaktniPodatkiEnum} from '../../../../../assets/js/Enum/KontaktniPodatkiEnum.js'
import {
  TableColumn, Input, Button, Form, Select, Option,
  Collapse, CollapseItem, Row, MessageBox, Tooltip, Loading
} from 'element-ui'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import KomponentaBrezEpredalov from './KomponentaBrezEpredalov'
import PsevdonimTooltip from './PsevdonimTooltip'
import Vue from 'vue'
import {StoritevEnum} from '../../../../../assets/js/Enum/StoritevEnum'
import OrderButton from '../../../../UIComponents/OrderButton.vue'
import T2Table from '../../../../UIComponents/T2Table.vue'
Vue.use(Loading)
export default {
  computed: {
    StoritevEnum () {
      return StoritevEnum
    },
    PredaliNaLastnihDomenah () {
      const groupBy = (array, key) => {
        const grouped = array.reduce((result, item) => {
          const group = item[key].split('@')[1]
          if (!result[group]) {
            result[group] = { predali: [], count: 0 }
          }
          result[group].predali.push(item)
          result[group].count++
          return result
        }, {})

        return grouped
      }
      return groupBy(this.seznamOstalihDomen, 'email')
    }
  },
  mixins: [PrikazVsebine, PretvorbaEnot],
  emits: ['refreshTab'],
  name: 'PregledPosthnigPredalov',
  components: {
    T2Table,
    OrderButton,
    PsevdonimTooltip,
    KomponentaBrezEpredalov,
    [Button.name]: Button,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input,
    [Form.name]: Form,
    [Select.name]: Select,
    [Option.name]: Option,
    [Row.name]: Row,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tooltip.name]: Tooltip,
    [MessageBox.name]: MessageBox
  },
  data () {
    return {
      stNarocenihMailov: 0,
      novoGeslo: '',
      potrjenoGeslo: '',
      omrezneDomene: '',
      seznamEmailov: [],
      izbranaVelikostiPredala: '',
      novPsevdonim: '',
      domena: '',
      mailZaUrejanjeObj: {},
      mailZaUrejanjeObjPravicaUrejanja: false,
      seznamNovihKreiranihEmailov: [],
      velikostPredala: '',
      emailZaKateregaPokazeNastavitve: '',
      seznamMoznihVelikosti: [],
      zasedenProstor: '',
      expandRowKeys: [],
      prikazeIkonoGeslo: true,
      prikazeIkonoPonoviteGeslo: true,
      nalaganjeTabeleMeilov: false,
      nalaganjePsevdonimov: false,
      nalaganjeInfoPredala: false,
      expandedRows: false,
      izbranaVelikostQuote: '',
      povezavaAdministrativneStoritveZasebno: '',
      povezavaWebmail: '',
      stTaba: 't1',
      povezavaElektronskaPosta: '',
      seznamT2Domen: [],
      dolzinaSeznamaT2Domen: null,
      seznamOstalihDomen: [],
      seznamDomainList: [],
      dodeljeniEmaili: [],
      izbranaT2Domena: '',
      izbranaLastnaDomena: '',
      t2Domene: [],
      lastneDomene: [],
      loadingGetSpremembaQote: false,
      podatkiIzbranegaDomainLista: [],
      inputs: [],
      kontaktniPodatki: null,
      formaOrientacija: 'left',
      mejnaSirina: 700,
      prvotnoIzbranaVelikost: '',
      primarnaDomena: '',
      removeMailText: 'Ste prepričani, da želite izbrisati elektronski predal',
      removeMailWarning: 'Pozor: Izbrisana bodo tudi vsa sporočila, ki jih imate v tem poštnem predalu! ',
      validacija: null
    }
  },
  props: {
    izbranPrikljucek: String,
    osvezitevStevec: Number,
    poslovnaStranka: String,
    seznamPrikljuckov: Array
  },
  watch: {
    izbranPrikljucek: function () {
      if (this.izbranPrikljucek !== null) {
        this.GetMozneDomenePrikljucka()
        this.GetEmaili()
      }
    },
    osvezitevStevec: function () {
      if (this.izbranPrikljucek !== null) {
        this.GetMozneDomenePrikljucka()
        this.GetEmaili()
      }
    }
  },
  mounted () {
    this.validacija = new Validacija()
    this.clientAgent = new ClientAgent()
    this.kontaktniPodatki = KontaktniPodatkiEnum
    if (this.izbranPrikljucek !== null) {
      this.GetEmaili()
      this.MozneVelikostiPredala()
      this.GetMozneDomenePrikljucka()
    } else {
      this.GetDodeljeniEmaili()
      this.nalaganjeTabeleMeilov = false
    }
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.povezavaAdministrativneStoritveZasebno = povezave.BASE_URL_ADMINISTRATIVNE_STORITVE_ZASEBNO
    this.povezavaWebmail = povezave.BASE_URL_WEBMAIL
    this.povezavaElektronskaPosta = povezave.BASE_URL_ELEKTRONSKA_POSTA
    this.validacija = new Validacija()
  },
  methods: {
    EmailOnPrimaryDomain (emailData) {
      return (this.primarnaDomena !== '' && emailData.email.includes(this.primarnaDomena)) ||
        emailData.email.includes('t-2.si') ||
        emailData.email.includes('t-2.net')
    },
    sortByPredal (a, b) {
      return a.email - b.email
    },
    sortByDate (a, b) {
      return (new Date(a.kreiran).getTime()) - (new Date(b.kreiran).getTime())
    },
    add () {
      this.inputs.push({
        email: ''
      })
    },
    remove (index) {
      MessageBox.confirm(
        'Ali ste prepričani, da želite odstraniti vnosno polje?', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
        this.inputs.splice(index, 1)
      }).catch((err) => {
        err = null
      })
    },
    PrikazGeslaDodajanjePostniPredal (id) {
      let element = document.getElementById(id)
      if (element.type === 'password') {
        element.type = 'text'
        if (id === 'novo-geslo') {
          this.prikazeIkonoGeslo = false
        } else {
          this.prikazeIkonoPonoviteGeslo = false
        }
      } else {
        element.type = 'password'
        if (id === 'novo-geslo') {
          this.prikazeIkonoGeslo = true
        } else {
          this.prikazeIkonoPonoviteGeslo = true
        }
      }
    },
    IzbranavrsticaDomainList (row) {
      this.inputs = []
      const id = row.email
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
      for (let i = 0; i < this.seznamDomainList.length; i++) {
        if (this.seznamDomainList[i].email === id) {
          for (let j = 0; j < this.seznamDomainList[i].ldap.mailforwardingaddress.length; j++) {
            let objektDomainList = {}
            objektDomainList.email = this.seznamDomainList[i].ldap.mailforwardingaddress[j]
            this.inputs.push(objektDomainList)
          }
        }
      }
    },
    Izbranavrstica (row, expandedRows) {
      const id = row.email
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
      if (row.nePrikazeGumba !== false && expandedRows.length > 0) {
        this.novPsevdonim = ''
        this.novoGeslo = ''
        this.potrjenoGeslo = ''
        this.GetPrikaziNastavitve(row.email)
      }
    },
    IzbranavrsticaLastnaDomena (row, expandedRows) {
      const id = row.email
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
      if (row.nePrikazeGumba !== false && expandedRows.length > 0) {
        this.novPsevdonim = ''
        this.novoGeslo = ''
        this.potrjenoGeslo = ''
        this.GetPrikaziNastavitve(row.email)
      }
    },
    GetEmaili () {
      if (this.izbranPrikljucek === null) {
        this.seznamEmailov = []
        return false
      }
      let hasPermission = this.HasPermission('EMAIL', false, 'id_prikljucek', this.izbranPrikljucek)
      if (!hasPermission) {
        this.seznamEmailov = []
        return false
      }
      this.nalaganjeTabeleMeilov = true
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/email/seznam',
        param,
        null,
        'SetEmaili',
        'ErrEmaili',
        25000)
    },
    SetEmaili (podatki) {
      this.seznamT2Domen = []
      this.seznamDomainList = []
      this.seznamOstalihDomen = []
      if (podatki.seznamEmailov !== null) {
        this.seznamEmailov = podatki.seznamEmailov
        for (let i = 0; i < this.seznamEmailov.length; i++) {
          if (this.seznamEmailov[i].idPrikljucek === Number.parseInt(this.izbranPrikljucek)) {
            if (this.validacija.JeT2Domena(this.seznamEmailov[i].email)) {
              this.seznamT2Domen.push(this.seznamEmailov[i])
            } else if (this.seznamEmailov[i].ldap !== null) {
              if (this.seznamEmailov[i].ldap.deliverymode.length > 0) {
                this.seznamDomainList.push(this.seznamEmailov[i])
              }
              if (this.seznamEmailov[i].ldap.deliverymode.length === 0) {
                this.seznamOstalihDomen.push(this.seznamEmailov[i])
              }
            }
            if (this.seznamEmailov[i].ldap !== null) {
              this.seznamEmailov[i].podatekSn = this.seznamEmailov[i].ldap.sn
            } else {
              this.seznamEmailov[i].podatekSn = ''
            }
            if (this.seznamEmailov[i].ldap === false) {
              this.seznamEmailov[i].nePrikazeGumba = false
            } else {
              this.seznamEmailov[i].nePrikazeGumba = true
            }
          }
        }
        this.stNarocenihMailov = podatki.steviloNarocenih
        this.nalaganjeTabeleMeilov = false
      } else {
        this.seznamEmailov = []
        this.nalaganjeTabeleMeilov = false
      }
      this.GetDodeljeniEmaili()
    },
    GetDodeljeniEmaili () {
      let param = ['permissionId=EMAIL']
      this.clientAgent.postWsRequest(
        this,
        'permissions/getAllPermissionsSharedWithMe',
        param,
        null,
        'SetEmailPermissionsSharedWithMe',
        'ErrEmaili')
    },
    SetEmailPermissionsSharedWithMe (podatki) {
      this.dodeljeniEmaili = []
      for (let i = 0; i < podatki.data.active.length; i++) {
        for (let j = 0; j < podatki.data.active[i].dovoljenja.length; j++) {
          if (podatki.data.active[i].dovoljenja[j].scope.includes('@')) {
            let obj = {}
            obj.email = podatki.data.active[i].dovoljenja[j].scope
            this.dodeljeniEmaili.push(obj)
          }
        }
      }
    },
    ErrEmaili (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    GetPrikaziNastavitve (email) {
      this.nalaganjeInfoPredala = true
      this.mailZaUrejanjeObj = null
      let param = ['email=' + email]
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/email/info',
        param,
        null,
        'SetPrikaziNastavitve',
        'ErrPrikaziNastavitve')
    },
    SetPrikaziNastavitve (podatki) {
      this.seznamNovihKreiranihEmailov = []
      this.zasedenProstor = ''
      this.velikostPredala = ''
      this.izbranaVelikostiPredala = ''
      this.izbranaVelikostQuote = ''
      this.mailZaUrejanjeObj = podatki
      this.mailZaUrejanjeObjPravicaUrejanja = this.HasPermission('PRIKLJUCKI', true, 'id_prikljucek', podatki.idPrikljucek.toString())
      let domena = podatki.ldap.mail
      domena = domena.substr(domena.indexOf('@') + 1)
      this.mailZaUrejanjeObj.domene = []
      this.mailZaUrejanjeObj.domene.push(domena)
      this.izbranaT2Domena = domena
      let porabaObjzasedenProstor = this.PretvoriKolicinoVPrijaznoOblikoB(
        this.mailZaUrejanjeObj.ldap.mailquota - this.mailZaUrejanjeObj.freespace)
      this.zasedenProstor = porabaObjzasedenProstor
      let porabaObjvelikostPredala = this.PretvoriKolicinoVPrijaznoOblikoB(
        this.mailZaUrejanjeObj.ldap.mailquota)
      this.velikostPredala = porabaObjvelikostPredala
      this.seznamNovihKreiranihEmailov = this.mailZaUrejanjeObj.ldap.mailalternateaddress
      let porabaObjizbranaVelikostiPredala =
        Number(this.PretvoriKolicinoVPrijaznoOblikoB(this.mailZaUrejanjeObj.ldap.mailquota).split('.')[0])
      this.izbranaVelikostiPredala = porabaObjizbranaVelikostiPredala
      this.prvotnoIzbranaVelikost = porabaObjizbranaVelikostiPredala
      let porabaObjPrimerjava = this.PretvoriVkB(this.mailZaUrejanjeObj.ldap.mailquota, 'kB')
      this.izbranaVelikostiZaPrimerjavo = (porabaObjPrimerjava.vrednost).toFixed(2) +
        ' ' + porabaObjPrimerjava.enota
      this.MozneVelikostiPredala()
      this.nalaganjeInfoPredala = false
    },
    ErrPrikaziNastavitve () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Tega e-predala ni možno urejati'
      this.ShowWarningMessage(paramObvestilo)
      this.nalaganjeInfoPredala = false
      this.expandRowKeys = []
    },
    DodajNovPsevdonim (email, domena) {
      let param = ['email=' + email]
      param.push('alias=' + this.novPsevdonim + '@' + domena)
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/email/createAlias',
        param,
        email,
        'SetDodajNovPsevdonim',
        'ErrDodajNovPsevdonim')
    },
    SetDodajNovPsevdonim (podatki, prenosniParam) {
      this.GetPrikaziNastavitve(prenosniParam)
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno dodan nov psevdonim.'
      this.ShowSuccessMessage(paramObvestilo)
      this.novPsevdonim = ''
    },
    ErrDodajNovPsevdonim (podatki) {
      this.ShowWarningMessage(podatki)
      this.novPsevdonim = ''
    },
    OdstraniPsevdonim (email, psevdonim) {
      this.nalaganjePsevdonimov = true
      MessageBox.confirm(
        'Ali ste prepričani, da želite odstraniti psevdonim (' + psevdonim + ') ?', {
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
        let param = ['email=' + email]
        param.push('alias=' + psevdonim)
        this.clientAgent.postWsRequest(this,
          'prikljucek/email/deleteAlias',
          param,
          email,
          'SetOdstraniPsevdonim',
          'ErrOdstraniPsevdonim')
      }).catch((err) => {
        err = null
        this.nalaganjePsevdonimov = false
      })
    },
    SetOdstraniPsevdonim (podatki, prenosniPodatki) {
      this.GetPrikaziNastavitve(prenosniPodatki)
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno odstranjen psevdonim.'
      this.ShowSuccessMessage(paramObvestilo)
      this.nalaganjePsevdonimov = false
    },
    ErrOdstraniPsevdonim (podatki) {
      this.ShowWarningMessage(podatki)
      this.nalaganjePsevdonimov = false
    },
    GetMozneDomenePrikljucka () {
      let hasPermission = this.HasPermission('EMAIL', false, 'id_prikljucek', this.izbranPrikljucek)
      if (!hasPermission) {
        return false
      }
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      this.omrezneDomene = []
      this.clientAgent.postWsRequest(this,
        'prikljucek/email/mozneDomene',
        param,
        null,
        'SetMozneDomenePrikljucka',
        'ErrMozneDomenePrikljucka')
    },
    SetMozneDomenePrikljucka (podatki) {
      this.omrezneDomene = []
      this.lastneDomene = []
      this.t2Domene = []
      this.primarnaDomena = podatki.data.primarnaDomena
      for (let i = 0; i < podatki.data.vseDomene.length; i++) {
        if (this.validacija.JeT2Domena(podatki.data.vseDomene[i])) {
          this.izbranaT2Domena = podatki.data.vseDomene[0]
          this.t2Domene.push(podatki.data.vseDomene[i])
        }
      }
      for (let i = 0; i < podatki.data.lastneDomene.length; i++) {
        this.izbranaLastnaDomena = podatki.data.lastneDomene[0]
        this.lastneDomene.push(podatki.data.lastneDomene[i])
      }
    },
    ErrMozneDomenePrikljucka (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    GetOdstraniPostniPredal (emailZaIzbris) {
      let param = ['email=' + emailZaIzbris]
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/email/delete',
        param,
        null,
        'SetOdstraniPostniPredal',
        'ErrOdstraniPostniPredal')
    },
    SetOdstraniPostniPredal (podatki) {
      this.izbrisMailaStatus = podatki.message
      if (this.izbrisMailaStatus === 'OK') {
        this.GetEmaili()
        this.$emit('refreshTab')
      }
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno odstranjen poštni predal'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrOdstraniPostniPredal (podatki) {
      this.ShowWarningMessage(podatki)
    },
    MozneVelikostiPredala () {
      this.seznamMoznihVelikosti = []
      for (let i = 1; i <= 50; i++) {
        this.seznamMoznihVelikosti.push(i)
      }
    },
    GetShraniNovoGeslo (email) {
      if (this.novoGeslo === this.potrjenoGeslo) {
        let param = ['geslo1=' + this.novoGeslo]
        param.push('geslo2=' + this.potrjenoGeslo)
        param.push('email=' + email)
        if (this.novoGeslo === '') {
          let paramObvestilo = {}
          paramObvestilo.message = 'Niste vnesli novih podatkov.'
          this.ShowWarningMessage(paramObvestilo)
          return false
        } else if (this.novoGeslo.length < 8) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Novo geslo mora imeti vsaj 8 znakov.'
          this.ShowWarningMessage(paramObvestilo)
          return false
        } else {
          this.clientAgent.postWsRequest(
            this,
            'prikljucek/email/changePassword?',
            param,
            null,
            'SetShraniNovoGeslo',
            'ErrShraniNovoGeslo')
        }
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'Gesli se ne ujemata.'
        this.ShowWarningMessage(paramObvestilo)
      }
    },
    SetShraniNovoGeslo (podatki) {
      if (podatki.status === 1) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Geslo uspešno posodobljeno.'
        this.ShowSuccessMessage(paramObvestilo)
      }
      this.novoGeslo = ''
      this.potrjenoGeslo = ''
      this.GetEmaili()
    },
    ErrShraniNovoGeslo (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      return false
    },
    GetSpremembaQuote (email) {
      if (this.zasedenProstor < this.izbranaVelikostiZaPrimerjavo) {
        this.GetPrikaziNastavitve(email)
        let paramObvestilo = {}
        paramObvestilo.message = 'Prostora na vašem poštnem predalu ne moremo zmanjšati. Prosimo, izbrišite ali ' +
          ' prenesite naprej sporočila v poštnem predalu ter nato ponovno odjavite prostor.'
        this.ShowWarningMessage(paramObvestilo)
      }
      if (this.izbranaVelikostiPredala === this.velikostPredala) {
        this.GetPrikaziNastavitve(email)
        let paramObvestilo = {}
        paramObvestilo.message = 'Izbrali ste enako velikost kot jo že imate naročeno.'
        this.ShowWarningMessage(paramObvestilo)
      } else {
        let param = ['email=' + email]
        param.push('quota=' + this.izbranaVelikostiPredala.split('.')[0] + 'G')
        this.clientAgent.postWsRequest(this,
          'prikljucek/email/changeQuota',
          param,
          email,
          'SetSpremembaQuote',
          'ErrSpremembaQuote')
      }
    },
    SetSpremembaQuote (podatki, email) {
      this.GetPrikaziNastavitve(email)
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno spremenjena velikost poštnega predala.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetEmaili()
      this.izbranaVelikostiPredala = ''
      this.loadingGetSpremembaQote = false
    },
    ErrSpremembaQuote (podatki) {
      this.ShowWarningMessage(podatki)
      this.loadingGetSpremembaQote = false
    },
    UpdateDomainlist (email) {
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      if (this.inputs.length > 0) {
        for (let i = 0; i < this.inputs.length; i++) {
          param.push('domainlist[]=' + this.inputs[i].email)
        }
      } else {
        param.push('domainlist[]=' + this.inputs)
      }
      param.push('email=' + email)
      this.clientAgent.postWsRequest(this,
        'prikljucek/email/updateDomainlist',
        param,
        null,
        'SetCreateDomainList',
        'ErrCreateDomainList')
    },
    SetCreateDomainList () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno posodobljen domain list.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetEmaili()
    },
    ErrCreateDomainList (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Nastavitve/Email/PregledPostnihPredalov.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/ElektronskaPosta/PregledPostnihPredalov.vue